<template>
  <div
    class="image-list"
    :style="{marginTop:marginTop+'px'}"
    :class="{borderTop:borderTop}"
  >
    <p
      v-if="title"
      class="image-list_title"
    >
      {{ $t(title) }}
    </p>
    <div
      v-if="cancel && imageList.length"
      class="image-list_content"
      :class="{outline:outline}"
    >
      <ImagePreviewButton
        v-for="(image_e,image_k) in imageList"
        :key="image_k"
        :small="small"
        :cancel="cancel"
        :percent="image_e.percent"
        :isloading="image_e.isloading"
        :text-label="image_e.url"
        :preview-url="image_e.previewUrl"
        @click="$_deleteImage(image_k)"
        @scroll-click="$_scrollClick()"
        @no-scroll="$_noScrollClick()"
      />
    </div>
    <div
      v-else-if="imageList.length"
      class="image-list_content"
      :class="{outline:outline}"
    >
      <ImagePreviewButton
        v-for="(image_e,image_k) in imageList"
        :key="image_k"
        :small="small"
        :text-label="image_e.url ? image_e.url : image_e"
        @click="$_deleteImage(image_k)"
        @scroll-click="$_scrollClick()"
        @no-scroll="$_noScrollClick()"
      />
    </div>
    <div
      v-else-if="noFileText"
      class="mt-20 ml-20"
    >
      <LvText h4>{{ $t(noFileText) }}</LvText>
    </div>
  </div>
</template>
<script>
export default {
  name: "ImageList",
  props: {
    title: {
      type: String,
      default: "",
    },
    imageList: {
      type: Array,
      default() {
        return [];
      },
    },
    outline: {
      type: Boolean,
      default: false,
    },
    cancel: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 8,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    noFileText: {
      type: String,
    },
  },
  methods: {
    $_deleteImage(index) {
      this.$emit("delete-img", index);
    },
    $_scrollClick() {
      this.$emit("scroll-click");
    },
    $_noScrollClick() {
      this.$emit("no-scroll");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/image-list";
</style>